import {fromLonLat} from 'ol/proj';

export function loadPlaceOnMap(feat, view) {
  const [longitude, latitude] = feat.geometry.coordinates;
  view.setCenter(fromLonLat([longitude, latitude]));
}
